import { useContext } from 'react';
import { cx } from '@trinity/chat-components/utils';
import { AppThemingContext } from '../../containers/AppTheming/Context';
import type { To } from '../../containers/Chat/RoutingProvider';
import { Link } from './Link';
import styles from './style/Back.module.css';

export type BackProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  primaryColor?: string;
  whitelabelEnabled?: boolean;
} & Partial<React.HTMLAttributes<HTMLDivElement>>;

export const Back = ({
  className,
  disabled: _disabled,
  label = 'Back',
  primaryColor,
  whitelabelEnabled,
  ...rest
}: BackProps) => {
  const themingContext = useContext(AppThemingContext);
  const enabled = whitelabelEnabled ?? themingContext?.enabled;
  const color = primaryColor ?? themingContext?.palette?.primary?.main ?? undefined;

  const style = {
    color: enabled && color ? color : undefined,
  };

  return (
    <div className={cx(styles.root, className)} style={style} {...rest}>
      {label}
    </div>
  );
};

type BackLinkProps = {
  className?: string;
  label?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  primaryColor?: string;
  to: To;
  whitelabelEnabled?: boolean;
};

export const BackLink = ({ className, label, onClick, primaryColor, to, whitelabelEnabled }: BackLinkProps) => (
  <Link to={to} onClick={onClick}>
    <Back className={className} label={label} primaryColor={primaryColor} whitelabelEnabled={whitelabelEnabled} />
  </Link>
);
